import ExpandableText from "@/components/ui/ExpandableText";
import SeoOnly from "@/components/seo/SeoOnly";

export type SeoBlockProps = {
  title: string;
  children: React.ReactNode;
};

export function SeoBlock({ title, children }: SeoBlockProps) {
  return (
    <div className="rounded-2xl border border-neutral-10 bg-constant-white p-6 shadow-sm sm:p-8">
      <h2 className="text-body-20 font-bold uppercase tracking-wide text-text-primary">{title}</h2>
      <ExpandableText
        collapsedHeight={60}
        className="mt-4"
        contentClassName="text-body-md leading-relaxed text-text-secondary"
        fadeClassName="h-14 bg-gradient-to-t from-constant-white to-transparent"
        buttonClassName="mt-3 inline-flex items-center gap-2 self-start rounded-full border border-blue-10 bg-constant-white px-1 py-1 pl-4 text-body-sm font-medium text-blue-80 transition-colors hover:border-blue-15 hover:bg-blue-5"
        expandedButtonClassName="border-blue-15 bg-blue-5 text-text-primary"
        iconWrapperClassName="border-blue-10 bg-blue-5/70"
        expandedIconWrapperClassName="border-blue-15 bg-constant-white"
        chevronColor="currentColor"
        expandLabel="Read more"
        collapseLabel="Read less"
      >
        <p>{children}</p>
      </ExpandableText>
    </div>
  );
}

export default function SamedaySeoBlocksSection() {
  return (
    <SeoOnly>
      <section className="w-full max-w-none" aria-label="Alberta delivery information">
      <div className="flex w-full flex-col gap-6">
        <SeoBlock title="Weed delivery in Alberta">
          Are you needing some delicious infused edible munchies? Looking to stock up on your preferred sativa, indica, or
          hybrid flower? Want access to the largest selection of cannabis products? Dank dispensaries in Alberta are
          here for you. Get access to mail order marijuana delivery to any postal code in Alberta shipped directly from
          the #1 dispensary in Calgary Alberta. We consider it our mission to supply Alberta residents the finest and
          most varied array of cannabis products.
        </SeoBlock>
        <SeoBlock title="Dank dispensaries that deliver in Alberta">
          End your &quot;Alberta Weed Delivery&quot; search here. Our delivery service gives you back the time you
          were going to spend driving. Catch up on a show, wrap up work, do whatever you want with it. Dank brings
          quality cannabis to your door at fair prices. Watch for deals and new arrivals on our menu. Same-day
          delivery, mail order, or in-store, we keep the experience consistent.
        </SeoBlock>
      </div>
    </section>
    </SeoOnly>
  );
}
